import { axios, handleError } from '../axios';

export const trashEmpty = () => {
  return new Promise((resolve) => {
    axios
      .post('admin/trash/empty/', {})
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
